import * as Sentry from '@sentry/react'

interface Props {
  children: React.ReactNode
  pageName?: string
}

export function PageErrorBoundary({ children, pageName }: Props) {
  return (
    <Sentry.ErrorBoundary
      fallback={() => (
        <div className="flex flex-col items-center justify-center py-20 px-4">
          <span className="material-symbols-outlined text-5xl text-[#cfd7e7] dark:text-gray-600 mb-4">
            error_outline
          </span>
          <h2 className="text-xl font-bold text-[#0d121b] dark:text-white mb-2">
            {pageName ? `${pageName} failed to load` : 'Something went wrong'}
          </h2>
          <p className="text-[#4c669a] dark:text-gray-400 mb-6 text-center max-w-md">
            An unexpected error occurred. Try refreshing or go back to the dashboard.
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2.5 text-sm font-bold text-white bg-[#1754cf] rounded-lg hover:opacity-90"
            >
              Refresh
            </button>
            <a
              href="/dashboard"
              className="px-4 py-2.5 text-sm font-medium text-[#4c669a] border border-[#e7ebf3] dark:border-white/10 rounded-lg hover:text-[#0d121b] dark:hover:text-white"
            >
              Dashboard
            </a>
          </div>
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
